<template>
  <div v-show="isShow">
    <!-- 视频地址输入 -->
    <div class="video-input">
      <el-input
        v-model="mValue"
        placeholder="请输入视频地址"
        @keyup.enter.native="playVideo"
      >
        <el-button slot="append" @click="playVideo" type="primary"
          >播放</el-button
        >
      </el-input>
    </div>

    <!-- 视频播放器 -->
    <div class="player-wrapper">
      <video
        ref="video"
        :src="currentUrl"
        controls
        width="100%"
        height="220"
        @loadedmetadata="onLoadedMetadata"
        @error="onError"
        @play="onPlay"
        @pause="onPause"
      ></video>
    </div>
  </div>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";

export default {
  name: "SchemaVideoUrlLink",
  mixins: [schemaMixin],
  props: {
    isShow: {
      default: true,
    },
  },
  data() {
    return {
      currentUrl: "",
      duration: 0,
      playing: false,
      currentTime: 0,
    };
  },
  computed: {
    progress() {
      if (!this.duration) return 0;
      return (this.currentTime / this.duration) * 100;
    },
  },
  mounted() {
    const video = this.$refs.video;
    video.addEventListener("timeupdate", this.onTimeUpdate);
  },
  beforeDestroy() {
    const video = this.$refs.video;
    video.removeEventListener("timeupdate", this.onTimeUpdate);
  },
  methods: {
    playVideo() {
      if (!this.mValue) {
        this.$message.warning("请输入视频地址");
        return;
      }
      this.currentUrl = this.mValue;
      this.$nextTick(() => {
        const video = this.$refs.video;
        video.load();
        video.play();
      });
    },
    onLoadedMetadata(e) {
      this.duration = e.target.duration;
    },
    onTimeUpdate(e) {
      this.currentTime = e.target.currentTime;
    },
    onPlay() {
      this.playing = true;
    },
    onPause() {
      this.playing = false;
    },
    onError() {
      console.log("视频加载失败");
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
    },
    formatProgress(percentage) {
      return `${percentage}%`;
    },
  },
};
</script>

<style scoped>
.video-container {
  max-width: 800px;
  margin: 20px auto;
}

.video-input {
  margin-bottom: 20px;
}

.player-wrapper {
  margin: 20px 0;
  background: #000;
  border-radius: 4px;
  overflow: hidden;
}

.video-info {
  margin-top: 15px;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
}
</style>
